module.exports = __webpack_public_path__ + "img/icon_map_13_off_010.d860142e.png";